export const phoneNumberFormat = (number) => {
  const ddd = number.substring(2, 4)
  const resto = number.substring(4)
  return `(${ddd}) ${insert(resto, resto.length - 4, '-')}`
}

const insert = (str, index, value) => {
  return str.substr(0, index) + value + str.substr(index)
}
